export const FILE_TYPE_JPG = { name: 'JPG', extensions: '.jpg .jpeg' }
export const FILE_TYPE_PNG = { name: 'PNG', extensions: '.png' }
export const FILE_TYPE_GIF = { name: 'GIF', extensions: '.gif' }
export const FILE_TYPE_HEIC = { name: 'HEIC', extensions: '.heic' }
export const FILE_TYPE_PDF = { name: 'PDF', extensions: '.pdf .PDF' }
export const FILE_TYPE_WORD = { name: 'Word', extensions: '.doc .docx' }
export const FILE_TYPE_EXCEL = { name: 'Excel', extensions: '.xls .xlsx' }
export const FILE_TYPE_CSV = { name: 'CSV', extensions: '.csv' }

export interface FileType {
  name: string
  extensions: string
}

export const FILE_TYPE_ALL: FileType[] = [
  FILE_TYPE_JPG,
  FILE_TYPE_PNG,
  FILE_TYPE_GIF,
  FILE_TYPE_HEIC,
  FILE_TYPE_PDF,
  FILE_TYPE_WORD,
  FILE_TYPE_EXCEL,
]

export const FILE_TYPE_IMAGES: FileType[] = [
  FILE_TYPE_JPG,
  FILE_TYPE_PNG,
  FILE_TYPE_GIF,
  FILE_TYPE_HEIC,
]

export const FILE_TYPE_AI_ENABLED_IMAGES: FileType[] = [
  FILE_TYPE_JPG,
  FILE_TYPE_PNG,
  FILE_TYPE_HEIC,
]

export const FILE_TYPE_SPREADSHEETS: FileType[] = [
  FILE_TYPE_EXCEL,
  FILE_TYPE_CSV,
]

export const FILE_TYPE_DOCUMENTS: FileType[] = [FILE_TYPE_PDF, FILE_TYPE_WORD]

export enum FileTypeGroup {
  ALL = 'ALL',
  IMAGES = 'IMAGES',
  SPREADSHEET = 'SPREADSHEET',
  DOCUMENT = 'DOCUMENT',
  AI_ENABLED_IMAGES = 'AI_ENABLED_IMAGES',
}

export const FileTypesByGroup = {
  [FileTypeGroup.ALL]: FILE_TYPE_ALL,
  [FileTypeGroup.IMAGES]: FILE_TYPE_IMAGES,
  [FileTypeGroup.SPREADSHEET]: FILE_TYPE_SPREADSHEETS,
  [FileTypeGroup.DOCUMENT]: FILE_TYPE_DOCUMENTS,
  [FileTypeGroup.AI_ENABLED_IMAGES]: FILE_TYPE_AI_ENABLED_IMAGES,
}
